// eslint-disable-next-line import/prefer-default-export
const background = {
  SOLID: 'solid',
  TRANSPARENT: 'transparent',
};

const backgroundColor = {
  transparent: 'rgba(66, 66, 66, 0.5)',
  solid: 'rgba(255, 255, 255)',
};

export {
  background,
  backgroundColor,
};
